import i18n from '../i18n';

const DEFAULT_API_BASE = 'https://api.parsdigitals.com/api';

export function resolveApiBase(configuredBase) {
  return (configuredBase?.trim() || DEFAULT_API_BASE).replace(/\/+$/, '');
}

const API_BASE = resolveApiBase(process.env.REACT_APP_API_URL);

export async function apiRequest(endpoint, options = {}) {
  const url = `${API_BASE}${endpoint}`;

  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || i18n.t('errors.apiRequestFailed', { status: response.status }));
  }

  return data;
}

export function createApiClient(getAccessToken) {
  return {
    async get(endpoint) {
      const token = getAccessToken();
      return apiRequest(endpoint, {
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });
    },

    async post(endpoint, body) {
      const token = getAccessToken();
      return apiRequest(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(body),
      });
    },

    async put(endpoint, body) {
      const token = getAccessToken();
      return apiRequest(endpoint, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(body),
      });
    },

    async del(endpoint) {
      const token = getAccessToken();
      return apiRequest(endpoint, {
        method: 'DELETE',
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });
    },
  };
}

export { API_BASE };
